var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"items yellow-scroll"},_vm._l((_vm.items),function(item,index){return _c('button',{key:index,ref:'targetRef'+index,refInFor:true,staticClass:"item",class:{ 'is-selected': index === _vm.selectedIndex },on:{"click":function($event){return _vm.selectItem(index)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }